module.exports = __webpack_public_path__ + "img/k.c7e2555c.jpg";